import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice loi des gaz parfaits (PV = nRT)";
const DESCRIPTION =
  "Calculatrice loi des gaz parfaits (PV = nRT). Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "ideal gas law calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/ideal-gas-law-calculator/";
function IdealGasLawCalculator() {
  const [pressure, setPressure] = useState("");
  const [volume, setVolume] = useState("");
  const [moles, setMoles] = useState("");
  const [temperature, setTemperature] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  // R = 8.314 J/(mol·K) or 0.08206 L·atm/(mol·K)
  const R = 8.314;
  const handleCalculate = () => {
    try {
      if (!pressure || !volume || !moles || !temperature) {
        setError("Veuillez entrer tous les paramètres");
        setResult(null);
        return;
      }
      const p = parseFloat(pressure);
      const v = parseFloat(volume);
      const n = parseFloat(moles);
      const t = parseFloat(temperature);
      if (p <= 0 || v <= 0 || n <= 0 || t < 0) {
        setError("Les valeurs doivent être positives");
        setResult(null);
        return;
      }
      // PV = nRT
      const pv = n * R * t;
      setResult({
        pv: pv.toFixed(2),
        proportional: (pv / (p * v)).toFixed(2)
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Application de la loi des gaz idéaux (PV = nRT) pour
                  calculer les relations entre pression, volume, moles et température.
                </p>
                <ul>
                  <li>Formule: PV = nRT</li>
                  <li>Constante R = 8.314 J/(mol·K)</li>
                  <li>Utile pour chimie et thermodynamique</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Pression (Pa)
                      </label>
                      <input
                        type="number"
                        value={pressure}
                        onChange={(e) => setPressure(e.target.value)}
                        placeholder="Pression"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Volume (m³)
                      </label>
                      <input
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Volume"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Moles (mol)
                      </label>
                      <input
                        type="number"
                        value={moles}
                        onChange={(e) => setMoles(e.target.value)}
                        placeholder="Moles"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Température (K)
                      </label>
                      <input
                        type="number"
                        value={temperature}
                        onChange={(e) => setTemperature(e.target.value)}
                        placeholder="Température en Kelvin"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>nRT (valeur attendue PV): <strong>{result.pv} J</strong></p>
                      <p>Rapport PV/nRT: <strong>{result.proportional}</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Rappel de la loi PV = nRT</h3></div>
              <div className="info-section-body">
                <p>La loi des gaz parfaits relie pression, volume, moles et temperature absolue. Elle est particulierement utile pour estimer le comportement d'un gaz dans des conditions proches de l'ideal.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Unites a respecter</h3></div>
              <div className="info-section-body">
                <p>Pour utiliser R = 8,314, entrez la pression en pascals, le volume en m³ et la temperature en kelvin. Si vous partez de degres Celsius, convertissez d'abord: T(K) = T(°C) + 273,15.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Applications en pratique</h3></div>
              <div className="info-section-body">
                <p>Cette relation sert a dimensionner des experiences de laboratoire, verifier des donnees de capteurs et comprendre l'effet d'une variation de temperature ou de pression sur un gaz.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default IdealGasLawCalculator;
